module.exports = __webpack_public_path__ + "static/media/13@1024w.5755ad66.jpg";